import React from 'react'

const EditDestDialogContext = React.createContext()

export default EditDestDialogContext